import { render, staticRenderFns } from "./Statically.vue?vue&type=template&id=ce7050ae&lang=pug&"
import script from "./Statically.vue?vue&type=script&lang=js&"
export * from "./Statically.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports